const React = require("react");
const T = React.PropTypes;

require("./Banner.less");

const CubeIcon = require("../CubeIcon/CubeIcon.jsx");
const UserInfo = require("../UserInfo/UserInfo.jsx");

const UserType = require("~/types/User.js").PropType;
const ErrorType = require("~/types/Error.js").PropType;
const navigator = require("~/navigator.js");

const Banner = React.createClass({
    propTypes: {
        User: UserType.isRequired,
        ImpersonationTransitioning: T.bool.isRequired,
        HomeLinkURL: T.string.isRequired
    },
    render() {
        const includeButtons = (this.props.User.Roles || []).length > 0;

        return (<header className="cs-Banner">
            <div className="cs-Banner__middle-box">
                <h1 className="cs-Banner__middle-box__title">
                    <span className="cs-Banner__middle-box__title__icon">
                        <CubeIcon Color="#fff" />
                    </span>
                    <span className="cs-Banner__middle-box__title__icon--print">
                        <CubeIcon Color="black" />
                    </span>
                    <span className="cs-Banner__middle-box__title__text">
                        SmartAudit
                    </span>
                    {includeButtons && (
                    <a href={this.props.HomeLinkURL} className="cs-Banner__middle-box__title__link">
                        Home
                    </a>)}
                    {includeButtons && (
                    <a href={"#" + navigator.GetLink.ToReports()} className="cs-Banner__middle-box__title__link">
                        Reporting
                    </a>)}
                </h1>
            </div>
            <div className="cs-Banner__right-box">
                <UserInfo User={this.props.User}
                          ImpersonationTransitioning={this.props.ImpersonationTransitioning} />
            </div>
        </header>);
    }
});

module.exports = Banner;


// WEBPACK FOOTER //
// ./src/components/Banner/Banner.jsx